$(document).ready(() => {
    var newDiv = document.createElement("div");
    newDiv.className = "swishlist-success-message alert-info";
    newDiv.innerHTML = "<p> Product removed from wishlist</p>";
    var headerInfo = document.querySelector("#main");
    var content = headerInfo.querySelector("#content");
    headerInfo.insertBefore(newDiv, content);
    $('.swishlist-success-message').hide();
    $('.wishlist-products-count-btn').text(swishlist.nbProducts);
    $(".wishlist-products-count-btn").attr('data-count',swishlist.nbProducts)

    getWishlistFromLocalStorage();
    $('body').on('click', '.js-swishlist-add', function (event) {
        event.preventDefault();
        let self = this;

        // Disable the button immediately
        $(self).addClass('disabled').prop('disabled', true);

        prestashop.emit('clickSWishlistAdd', {
            dataset: self.dataset,
            self: self
        });

        // Save data to localStorage
    });

    $('body').on('click', '.js-swishlist-remove', function (event) {

        let self = this;
        removeFromWishlist($(this).data('id-product-wish'))
        prestashop.emit('clickSWishlistRemove', {
            dataset: self.dataset
        });

        event.preventDefault();
        $('.swishlist-success-message').show();
        if (swishlist.nbProducts == 0) {
            location.reload();
            $('#swishlist-crosseling, #swishlist-share').addClass('hidden-xs-up');
        }
    });


    prestashop.on('clickSWishlistAdd', function (elm) {
        let data = {
            'process': 'add',
            'ajax': 1,
            'idProduct': elm.dataset.idProduct,
            'idProductAttribute': elm.dataset.idProductAttribute,
        };
        let wishlist = JSON.parse(localStorage.getItem("id_product_wishlist")) || [];
        let productId = elm.dataset.idProduct;
        if (!wishlist.includes(productId)) {
            wishlist.push(productId);
        }
        localStorage.setItem("id_product_wishlist", JSON.stringify(wishlist));

        $.post(elm.dataset.url, data, null, 'json').then(function (resp) {

            if (!resp.success && resp.data.type == 'notLogged'){
                let quickModal = $('.modal.quickview').first();

                if (quickModal.length){
                    $(quickModal).modal('hide');
                    $(quickModal).on('hidden.bs.modal', function (e) {
                        $('#swishlist-modal').modal('show');
                    });
                } else{
                    $('#swishlist-modal').modal('show');
                }
                return;
            }
            $(elm.self).addClass('swishlist-added');
            if (resp.success){
                swishlist.nbProducts++;
                $('.wishlist-products-count-btn').text(swishlist.nbProducts);
                $(".wishlist-products-count-btn").attr('data-count',swishlist.nbProducts)

                let $notification =  $('#swishlist-notification');
                $notification.addClass('ns-show');

                setTimeout(function(){
                    $notification.removeClass('ns-show');
                }, 3500);
            }

        }).fail((resp) => {
            prestashop.emit('handleError', {eventType: 'clickSWishlistAdd', resp: resp});
        });

    });

    prestashop.on('clickSWishlistRemove', function (elm) {

        let data = {
            'process': 'remove',
            'ajax': 1,
            'idProduct': elm.dataset.idProduct,
        };
        $.post(elm.dataset.url, data, null, 'json').then(function (resp) {
            console.log('#swishlist-product-' + elm.dataset.idProduct);
            let swishlistProductRemove = $('#swishlist-product-' + elm.dataset.idProduct).remove();
            swishlist.nbProducts--;
            $('.wishlist-products-count-btn').text(swishlist.nbProducts);
            $(".wishlist-products-count-btn").attr('data-count',swishlist.nbProducts)
            if(swishlistProductRemove){
                $('.swishlist-success-message').show()
            }
            if (swishlist.nbProducts == 0) {
                $('#swishlist-warning').removeClass('hidden-xs-up');
                $('#swishlist-crosseling, #swishlist-share').addClass('hidden-xs-up');
            }
        }).fail((resp) => {
            prestashop.emit('handleError', {eventType: 'clickSWishlistRemove', resp: resp});
        });

    });

    prestashop.on('updatedProduct', function (elm) {
        $('#studio-wishlist-product-btn').data('id-product-attribute', elm.id_product_attribute);
        $('#studio-wishlist-product-btn').attr('data-id-product-attribute', elm.id_product_attribute);
    });


    $('#swishlist-clipboard-btn').on('click', function () {

        var $btn = $(this);

        var copyInput = $btn.closest('.input-group').children('input.js-to-clipboard');
        copyInput.select();

        try {
            var successful = document.execCommand('copy');
            if (successful) {
                $btn.text($btn.data('textCopied'));
                setTimeout(function(){ $btn.text($btn.data('textCopy'));  }, 1500);
            }
        } catch (err) {
            console.log('Oops, unable to copy');
        }
    });


    $('.add-to-cart-all').click(function () {

        let ajax_url = $(this).attr('data-action-url');
        $.ajax({
            url: ajax_url,
            type: 'post',
            dataType: 'json',
            data: {
                action: 'addAllToCart',
            },
            success: function (json) {
                if (json.success === true) {
                    if (typeof json.data.message !== undefined) {
                        $('.action-buttons .cart-info').html(json.data.message);
                        $('.action-buttons .cart-info').removeClass('d-none');

                        location.href = json.data.redirect_url;
                    }
                }
            }
        });
    });

    $(document).on('submit', '#swishlist-share-form', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        console.log('here');

        const $form = $(this);
        const email = $form.find('input[name="email"]').val();
        const actionUrl = $form.find('button[type="submit"]').data('action-url');

        fetch(actionUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: new URLSearchParams({
                action: 'shareWishlist',
                email: email
            })
        })
            .then(res => res.json())
            .then(data => {
                $('#swishlist-share-success, #swishlist-share-error').addClass('d-none');

                if (data.success) {
                    $('#swishlist-share-success').text(data.message).removeClass('d-none');
                    $form[0].reset();
                } else {
                    $('#swishlist-share-error').text(data.message).removeClass('d-none');
                }
            })
            .catch(() => {
                $('#swishlist-share-error').text('Something went wrong. Please try again.').removeClass('d-none');
            });
    });

});

function getWishlistFromLocalStorage() {
    let wishlist = JSON.parse(localStorage.getItem("id_product_wishlist")) || [];
    console.log("Wishlist from localStorage:", wishlist);

    wishlist.forEach(function(productId) {
        // Build the class name based on product ID
        let className = `.js-product-miniature-wrapper-${productId}`;
        // Add your desired class to matching elements
        $(className).addClass("in-wishlist");
        $(`.js-swishlist-add[data-id-product="${productId}"]`).parents('.col-add-wishlist').addClass("in-wishlist");
        $(`.js-swishlist-add[data-id-product="${productId}"]`).addClass('swishlist-added');
    });
}
function removeFromWishlist(productIdToRemove) {
    let wishlistRaw = localStorage.getItem("id_product_wishlist");
    let wishlist = JSON.parse(wishlistRaw) || [];
    wishlist = wishlist.filter(id => id !== String(productIdToRemove));
    localStorage.setItem("id_product_wishlist", JSON.stringify(wishlist));

}
